import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {MatPaginator} from '@angular/material/paginator';
import {HrService} from '../hr.service';
import {WorkAbroad} from "../../admin/models/workAbroad.model";
import {FormControl} from "@angular/forms";
import {PersonalService} from "../../personal/personal.service";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
    selector: 'app-decline-pop-up',
    templateUrl: './edit-work-abroad-pop-up.component.html',
    styleUrls: ['./edit-work-abroad-pop-up.component.scss']
})
export class EditWorkAbroadComponent implements OnInit {
    public workAbroad = {} as WorkAbroad;
    public isPageLoading = false;
    public startDate = new FormControl(new Date());
    public endDate = new FormControl(new Date());
    public firstDayBack = new FormControl(new Date());
    public lastDayWorking = new FormControl(new Date());

    @ViewChild(MatPaginator) paginator: MatPaginator | undefined;

    constructor(public dialogRef: MatDialogRef<[]>,
                private readonly fabMessageService: FabMessageService,
                private readonly hrService: HrService,
                private readonly personalService: PersonalService,
                @Inject(MAT_DIALOG_DATA) public selectedData: any) {
    }

    ngOnInit(): void {
        this.workAbroad = this.selectedData.value;
        this.workAbroad.startDate = this.formatDate(this.workAbroad.startDate);
        this.workAbroad.endDate = this.formatDate(this.workAbroad.endDate);
        this.startDate.patchValue(new Date(this.personalService.swapDateAndMonth(this.workAbroad.startDate)));
        this.endDate.patchValue(new Date(this.personalService.swapDateAndMonth(this.workAbroad.endDate)));
        this.firstDayBack.patchValue(new Date(this.personalService.swapDateAndMonth(this.workAbroad.firstDayBack)));
        this.lastDayWorking.patchValue(new Date(this.personalService.swapDateAndMonth(this.workAbroad.lastDayWorking)));
    }

    /**
     * Takes a string, number or Date object as input and
     * returns a formatted date string in the format 'DD/MM/YYYY'.
     * It pads the day and month with a leading zero if necessary
     * @param dateString
     */
    formatDate(dateString: string | number | Date) {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    close(): void {
        this.dialogRef.close();
    }

    /**
     * Sets the employee dateStarted from the formControl object
     */
    public setModelDate() {
        this.workAbroad.startDate = this.startDate.value!.toString();
        this.workAbroad.endDate = this.endDate.value!.toString();
        this.workAbroad.firstDayBack = this.firstDayBack.value!.toString();
        this.workAbroad.lastDayWorking = this.lastDayWorking.value!.toString();
        this.workAbroad.startDate = this.hrService.convertDateFormatForAPI(this.workAbroad.startDate);
        this.workAbroad.endDate = this.hrService.convertDateFormatForAPI(this.workAbroad.endDate);
        this.workAbroad.firstDayBack = this.hrService.convertDateFormatForAPI(this.workAbroad.firstDayBack);
        this.workAbroad.lastDayWorking = this.hrService.convertDateFormatForAPI(this.workAbroad.lastDayWorking);
    }

    public edit(data: any) {
        this.setModelDate();
        this.isPageLoading = true;
        this.hrService.editWorkAbroad(data).subscribe({
            next: () => {
                this.fabMessageService.displayMessage('success');
                this.isPageLoading = false;
                this.close();
            }, error: (err: HttpErrorResponse) => {
                this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                this.isPageLoading = false;
            }
        });
    }
}
